import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { BreadcrumbSection } from './product-detail/BreadcrumbSection';
import { MediaAndInfoSection } from './product-detail/MediaAndInfoSection';
import { SpecificationsSection } from './product-detail/SpecificationsSection';
export function ProductDetailPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-3634">
      <SeoBar data-id="element-3635" />
      <Header data-id="element-3636" />
      <main className="flex-grow" data-id="element-3637">
        <div className="w-full bg-gray-50 pb-20 min-h-screen font-sans" data-id="element-3638">
          <BreadcrumbSection data-id="element-3639" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-3640">
            <MediaAndInfoSection data-id="element-3641" />
            <SpecificationsSection data-id="element-3642" />
          </div>
        </div>
      </main>
      <Footer data-id="element-3643" />
    </div>;
}